import React from 'react';
import s from '@Pages/Detail/styles/PriceBox.module.css';
import { MembershipPricesProps } from '@Pages/Detail/props';

export const InitialPiceBox = (props: MembershipPricesProps) => {
    const priceUnit = props.isJpy ? '万' : 'THB';

    return (
        <>
            <div className={s.initial_offering_price_area}>
                <div className={s.inner}>
                    <div className={`${s.tag}`}>新規募集</div>
                    <div className={s.text}>入会総額：</div>
                    <div className={s.price}>
                        {props.membership.isAsk ? (
                            <span>ご相談</span>
                        ) : (
                            <>
                                {props.membership.totalBudget || '-'}
                                <span>{props.membership.totalBudget ? priceUnit : ''}</span>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className={s.budget_info}>
                <div className={s.budget_info_box}>
                    <p className={s.budget_info_text}>
                        <span className={s.icon_round} />
                        入会総額：
                        {props.membership.isAsk ? (
                            <span className={s.budget}>ご相談</span>
                        ) : (
                            <span className={s.budget}>
                                {props.membership.totalBudget || '-'}
                                {priceUnit}
                            </span>
                        )}
                    </p>
                    <p className={s.budget_info_text}>
                        <span className={s.icon_round} />
                        年会費：
                        <span className={s.annual_fee}>
                            {props.membership.annualFee || '-'}
                            {props.isJpy ? '円' : 'THB'}
                        </span>
                    </p>
                </div>
                <p className={s.budget_mini_info}>
                    (入会金: {props.membership.sellingPrice || '-'}
                    {props.isJpy ? '万円' : 'THB'}/入会預託金: {props.membership.deposit || '-'}
                    {priceUnit})
                </p>
                {props.playguideUrl && (
                    <div className={s.playguide_link_box}>
                        <a
                            href={props.playguideUrl}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={s.playguide_link}
                        >
                            プレイガイドはこちら
                        </a>
                    </div>
                )}
            </div>
            <div className={s.info_footer}>
                <div className={s.info_caution}>
                    <p>※{props.membership.version}現在(税込価格)</p>
                    <p>※総予算＝入会金＋入会預託金</p>
                </div>
            </div>
        </>
    );
};

export default InitialPiceBox;
